/**
 * rebuy-cart-fix.js
 * Intercepts Rebuy's ATC flow on every page type:
 *  - Prevents redirect by blocking navigation while the add is in-flight
 *  - Piggybacks sections=cart-drawer onto Rebuy's own /cart/add.js (zero extra roundtrip)
 *  - Swaps cart-drawer HTML and opens/refreshes the drawer via theme events
 *  - Clears stuck aria-busy states on bfcache restore (collection grid ATC spinner bug)
 */
(function () {
  'use strict';

  // Skip cart page
  if (window.location.pathname === ((window.Shopify?.routes?.cart) || '/cart')) return;

  const SECTIONS    = ['cart-drawer'];
  const ADD_RE      = /\/cart\/add(\.js)?(\?|$)/;
  const native      = window.fetch.bind(window);

  let pending = false, inDrawer = false, cachedHtml = null, activeBtn = null, timer = null;

  function arm(btn, drawer) {
    pending = true; inDrawer = drawer; cachedHtml = null; activeBtn = btn;
    clearTimeout(timer);
    timer = setTimeout(reset, 10000);
  }

  function reset() {
    // activeBtn?.removeAttribute('aria-busy');
    pending = false; inDrawer = false; cachedHtml = null; activeBtn = null;
    clearTimeout(timer); timer = null;
  }

  function updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(el => el.setAttribute('data-cart-count', n));
    document.querySelector('.layout--viewport')?.setAttribute('data-cart-empty', String(n === 0));
  }

  function openDrawer() {
    window.dispatchEvent(new Event('theme:transition:reset:cart-drawer'));
    window.dispatchEvent(new CustomEvent('theme:drawer:open', { detail: { side: 'right', view: 'cart-drawer', trigger: null } }));
  }

  // bfcache: clear stuck busy states before snapshot and after restore.
  // Also clears on every pageshow (not just bfcache) so navigating back always
  // resets any spinner that was mid-flight when the user left the page.
  function clearBusy() {
    document.querySelectorAll('[aria-busy="true"].product-buy-buttons--primary,[aria-busy="true"].product-buy-buttons--buy-now,product-quick-add[aria-busy],.rebuy-button[aria-busy],.shop-the-look--add[aria-busy]')
      .forEach(el => el.setAttribute('aria-busy', 'false'));
  }
  window.addEventListener('pagehide', e => { if (e.persisted) clearBusy(); });
  window.addEventListener('pageshow',  clearBusy);

  // Fetch patch: append sections to Rebuy's /cart/add.js so HTML comes back in the same response
  window.fetch = async function (input, init) {
    const url = input instanceof Request ? input.url : String(input);
    if (!pending || !ADD_RE.test(url)) return native(input, init);

    init = { ...(init || {}) };
    try {
      const h  = init.headers || {};
      const ct = typeof h.get === 'function' ? (h.get('content-type') || h.get('Content-Type') || '') : (h['Content-Type'] || h['content-type'] || '');
      if (!ct || ct.includes('application/json')) {
        const body = init.body ? JSON.parse(init.body) : {};
        body.sections = SECTIONS;
        init.body = JSON.stringify(body);
        typeof h.set === 'function' ? h.set('Content-Type', 'application/json') : (init.headers = { ...h, 'Content-Type': 'application/json' });
      } else {
        const p = new URLSearchParams(init.body || '');
        SECTIONS.forEach(s => p.append('sections[]', s));
        init.body = p.toString();
      }
    } catch (_) {}

    const res = await native(input, init);
    try {
      const d = await res.clone().json();
      if (d?.sections?.['cart-drawer']) cachedHtml = d.sections['cart-drawer'];
      if (typeof d?.item_count === 'number') updateCount(d.item_count);
    } catch (_) {}
    return res;
  };

  // Arm on any .rebuy-button click (capture phase, all locations)
  document.addEventListener('click', e => {
    const btn = e.target.closest('.rebuy-button');
    if (btn) arm(btn, !!(btn.closest('cart-element[data-view="drawer"]') || btn.closest('.rebuy-cart')));
  }, true);

  // Block redirect while add is in-flight (Navigation API: Chrome/Edge 102+, Safari 18+)
  if (window.navigation) {
    window.navigation.addEventListener('navigate', e => {
      if (!pending) return;
      try { if (new URL(e.destination.url).pathname !== location.pathname) e.preventDefault(); } catch (_) {}
    });
  }

  // On Rebuy cart change: swap drawer HTML then open or refresh
  document.addEventListener('rebuy:cart.change', async () => {
    if (!pending) return;
    let html = cachedHtml;
    const wasInDrawer = inDrawer;

    if (!html) {
      try {
        const r = await native((window.Shopify?.routes?.cart_update ?? '/cart/update') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ sections: SECTIONS })
        });
        if (r.ok) {
          const d = await r.json();
          html = d.sections?.['cart-drawer'];
          if (typeof d.item_count === 'number') updateCount(d.item_count);
        }
      } catch (_) {}
    }

    if (html) {
      // Parse item count from section HTML and update header badge immediately.
      // /cart/add.js doesn't return item_count, so we extract it from the
      // rendered [data-cart-count] pill (textContent = {{ cart.item_count }}).
      try {
        const tmp = new DOMParser().parseFromString(html, 'text/html');
        const n = parseInt(tmp.querySelector('[data-cart-count]')?.textContent, 10);
        if (!isNaN(n)) updateCount(n);
      } catch (_) {}

      window.addEventListener('theme:cart:updated', () => { reset(); if (!wasInDrawer) openDrawer(); }, { once: true });
      window.dispatchEvent(new CustomEvent('theme:cart:drawer:updateHtml', { detail: { section: html, load_transitions: false } }));
    } else {
      reset();
      if (!wasInDrawer) openDrawer();
    }
  });
})();

